
import { defineComponent, ref, toRefs } from 'vue';
import Axios from '@/core/services/Http';
import { Notify } from '@/core/services';
import { Modal } from 'bootstrap';
import { useI18n } from 'vue-i18n';
import InnerLoader from '@/components/InnerLoader.vue';

export default defineComponent({
    name: 'Individual Customers',
    components: {
        InnerLoader
    },
    props: {
        erp_enable: Number,
        sync_product_enable: Number
    },
    setup(props) {
        const modal: any = ref();
        const i18n = useI18n();
        const reports = ref([]) as Record<any, any>;
        const economic_number = ref('');
        const loading = ref(false);

        const getIndividualProduct = async () => {
            if(props.erp_enable == 0 || props.sync_product_enable == 0)
            {
                Notify.error(i18n.t('message.SERVICE_NOT_ENABLED'));
                return;
            }
            if (economic_number.value != '') {
                const formData = {
                    economic_number: economic_number.value
                };
                loading.value = true;
                try {
                    const response = await Axios.post('/sap/get-bridge-product', formData);
                    loading.value = false;
                    if (response.data.status == 404) {
                        Notify.error(i18n.t('message.PRODUCT'));
                        return;
                    }
                    if (response?.data?.report?.length > 0) {
                        reports.value = response?.data?.report;
                        modal.value = new Modal(document.getElementById('show_report_for_individual_product')) as HTMLElement;
                        modal.value.show();
                    } else {
                        Notify.success(i18n.t('message.PRODUCTS_SYNC_SUCCESSFULLY'));
                    }
                } catch ($e) {
                    Notify.error($e);
                    loading.value = false;
                }
            }
        };

        return {
            loading,
            economic_number,
            reports,
            getIndividualProduct
        };
    }
});
